import React from 'react';
import { GridColumnMenuProps, GridColumnMenu } from '@mui/x-data-grid-premium';

const CustomColumnMenu = (props: GridColumnMenuProps) => {
  return (
    <GridColumnMenu
      {...props}
      slots={{
        columnMenuFilterItem: null,
        columnMenuAggregationItem: null,
        columnMenuGroupingItem: null,
      }}
    />
  );
};

export default CustomColumnMenu;
